<template>
  <el-row :gutter="20">
    <el-col
      :span="12"
      :offset="6">
      <div class="content-area-txt-tab">
        Bring your production team and audience together in real-time.TVU
        Partyline is the industry’s only real-time, ultra-low latency,
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {}
</script>
<style scoped>
.content-area-txt-tab {
  padding: 20px 20px;
  text-align: center;
  color: #808080;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
</style>
